import { useDispatch } from 'react-redux';
import {
  setDeleteFromAllInvitationSources,
  setInvitationSourceMappingsToDelete,
  setIsDeleteInvitationSourceMappingsPanelOpen,
  setIsDeleteInvitationSourcePanelOpen,
} from '../../../../../../../features/pageFeatures/createHearingPageSlice';

export const useInteractions = () => {
  const dispatch = useDispatch();

  function handleDeleteInvitationSourceMappingGroup() {
    dispatch(setIsDeleteInvitationSourcePanelOpen(true));
  }

  function handleDeleteInvitationSourceMapping(invitationSourceMappingKey) {
    dispatch(setInvitationSourceMappingsToDelete([invitationSourceMappingKey]));
    dispatch(setDeleteFromAllInvitationSources(false));
    dispatch(setIsDeleteInvitationSourceMappingsPanelOpen(true));
  }

  function handleDeleteInvitationSourceMappingsForUserOrCompany(
    invitationSourceMappingKey,
  ) {
    dispatch(setInvitationSourceMappingsToDelete([invitationSourceMappingKey]));
    dispatch(setDeleteFromAllInvitationSources(true));
    dispatch(setIsDeleteInvitationSourceMappingsPanelOpen(true));
  }

  return {
    handleDeleteInvitationSourceMappingGroup,
    handleDeleteInvitationSourceMapping,
    handleDeleteInvitationSourceMappingsForUserOrCompany,
  };
};
